if (!customElements.get('cart-progress')) {
  customElements.define(
    'cart-progress',
    class CartProgress extends HTMLElement {
      connectedCallback() {
        this.progressBar = this.querySelector('.cart-progress__bar__progress');
        this.messageElement = this.querySelector('.cart-progress__text');
        this.goalCents = Number(this.dataset.goalCents);
        this.refreshPromise = null;

        if (!this.progressBar || !this.messageElement || !Number.isFinite(this.goalCents)) return;

        this.onCartUpdated = this.onCartUpdated.bind(this);
        document.addEventListener('cartUpdated', this.onCartUpdated);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const cartData = event && event.cartData;

            if (cartData && Number.isFinite(Number(cartData.items_subtotal_price))) {
              this.update(cartData.items_subtotal_price);
              return;
            }

            this.refresh();
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('cartUpdated', this.onCartUpdated);

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = null;
        }
      }

      onCartUpdated() {
        this.refresh();
      }

      refresh() {
        if (this.refreshPromise) return this.refreshPromise;

        this.refreshPromise = fetch(`${window.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
            return response.json();
          })
          .then((cart) => {
            if (cart && Number.isFinite(Number(cart.items_subtotal_price))) {
              this.update(cart.items_subtotal_price);
            }
          })
          .catch((error) => console.error('Unable to update free-shipping progress:', error))
          .finally(() => {
            this.refreshPromise = null;
          });

        return this.refreshPromise;
      }

      update(subtotalCents) {
        const subtotal = Math.max(0, Number(subtotalCents) || 0);
        const goalReached = this.goalCents <= 0 || subtotal >= this.goalCents;
        const progress = goalReached ? 100 : Math.min(100, (subtotal / this.goalCents) * 100);

        this.progressBar.style.width = `${progress.toFixed(2)}%`;

        if (goalReached) {
          this.messageElement.textContent = this.dataset.successMessage || '';
          return;
        }

        const remaining = Math.max(0, this.goalCents - subtotal);
        this.messageElement.textContent = (this.dataset.message || '').replace(
          '[amount]',
          this.formatMoney(remaining)
        );
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);

        if (!placeholder) return (cents / 100).toFixed(2);

        const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
          const fixed = (number / 100).toFixed(precision);
          const parts = fixed.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts.join(precision ? decimal : '');
        };

        let value;
        switch (placeholder[1]) {
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          default:
            value = formatWithDelimiters(cents);
        }

        return format.replace(placeholder[0], value);
      }
    }
  );
}
